import Lozenge from '@atlaskit/lozenge';
import VisuallyHidden from '@atlaskit/visually-hidden';
import * as React from 'react';
import { SupportAvailability } from '../../types';
import { getPartnerSupportAvailability } from '../../utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CurrentSupportAvailability = _ref => {
  let {
    availability
  } = _ref;
  if (!availability) {
    return null;
  }
  const availabilityType = getPartnerSupportAvailability({
    availability,
    localTime: Date.now()
  });
  const getLozenge = () => {
    if (availabilityType === SupportAvailability.Open) {
      return /*#__PURE__*/_jsx(Lozenge, {
        appearance: "success",
        children: "Open now"
      });
    }
    if (availabilityType === SupportAvailability.OnHoliday) {
      return /*#__PURE__*/_jsx(Lozenge, {
        appearance: "default",
        children: "Closed (Holiday)"
      });
    }
    return /*#__PURE__*/_jsx(Lozenge, {
      appearance: "default",
      children: "Closed"
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(VisuallyHidden, {
      children: "Support availability:"
    }), getLozenge()]
  });
};